import React from "react";
import { useNavigate } from 'react-router-dom';
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import {
  CalendarMonthOutlined,
  CallMissedOutlined,
  FeedOutlined,
  MapOutlined,
  QuickreplyOutlined,
} from "@mui/icons-material";
import {
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import SceneBox from "components/SceneBox";

export default function AppsHub() {
  const theme = useTheme();
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  const navigate = useNavigate();
  
  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header title="APPS" subtitle="Sales Form" />
        <Box>
        </Box>
      </FlexBetween>

      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 1 */}
        <SceneBox
          value="Devis Event"
          onClick={() => {
                window.open('https://flairflow.aidaform.com/questionnaire-ev-nement-flair-flow-copy');
              }}
          icon={
            <FeedOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Devis Atelier"
          onClick={() => {
                window.open('https://flairflow.aidaform.com/atelier-questionnaire-devis');
              }}
          icon={
            <FeedOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
      <FlexBetween marginTop={5}>
        <Header title="" subtitle="Logistic Form"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 2 */}
        <SceneBox
                  value="Liste de Course"
          onClick={() => {
                window.open('https://flairflow.aidaform.com/Selectioncocktails');
              }}
          icon={
            <FeedOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
      <FlexBetween marginTop={5}>
        <Header title="" subtitle="Apps"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 3 */}
        <SceneBox
          value="Calendar"
          onClick={() => {
                navigate("/calendar");
              }}
          icon={
            <CalendarMonthOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Replier"
          onClick={() => {
                navigate("/replier");
              }}
          icon={
            <QuickreplyOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="KM Route Calculator"
          onClick = {() => {
              window.open('https://docs.google.com/spreadsheets/d/1CyefH0tIG-NpCIRM1yOlbvEQsZsMYrCsU7O0JGzTowI/edit?usp=drive_link');
            }}
          icon={
            <MapOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
          </Box>
          <FlexBetween marginTop={5}>
        <Header title="" subtitle="Quicktalk"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 4 */}
        
        <SceneBox
          value="Calls"
          onClick = {() => {
              window.open('https://app.quicktalk.com/calls');
            }}
          icon={
            <CallMissedOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
    </Box>
  );
};